import {
    archizeenTileClassName,
    SubheaderClassName,
    tileImageClassName,
    tileImageSlotClassNames,
    flexClassName,
    captionClassName,
    labelClassName,
} from '@archipro-design/aria';
import type { StyleRule } from '@archipro-design/aria';
import { pxToRem, pxArrayToRem } from '@archipro-design/aria';

export const StickyWrap: StyleRule = ({ theme }) => ({
    display: `flex`,
    position: `sticky`,
    top: pxToRem(10),
    maxHeight: `100vh`,
    width: pxToRem(720),

    [theme.screen.clamped]: {
        width: '50%',
    },
});

export const MainTile: StyleRule = ({ theme }) => ({
    [`&.${archizeenTileClassName}`]: {
        [`& .${tileImageClassName}`]: {
            maxHeight: `calc(100vh - ${pxToRem(196)})`,
            [`& > div`]: {
                maxHeight: `calc(100vh - ${pxToRem(196)})`,
            },
        },
        [`& .${tileImageSlotClassNames.imageContainer}`]: {
            maxHeight: `calc(100vh - ${pxToRem(196)})`,
        },

        [`& >*:not(:first-child)`]: {
            margin: `${theme.siteVariables.spaces['space-24']} 0 0`,
        },

        [theme.screen.clamped]: {
            [`&.${archizeenTileClassName}`]: {
                width: '100%',
                [`& .${tileImageClassName}`]: {
                    width: '100%',
                    [`& > div`]: {
                        width: '100%',
                    },
                },
                [`& .${tileImageSlotClassNames.imageContainer}`]: {
                    width: '100%',
                },
            },
        },
    },
});

export const MainWrap: StyleRule = () => ({
    flex: `1 0 auto`,
    maxWidth: `50%`,
});

export const TopArticleGrid: StyleRule = ({ theme }) => ({
    gridGap: `${theme.siteVariables.spaces['space-60']} 0`,

    '&:last-child': {
        [theme.screen.laptop]: {
            marginBottom: pxToRem(60),
        },
    },

    [theme.screen.clamped]: {
        gridTemplateColumns: `repeat(2, 50%)`,

        [`& .${archizeenTileClassName}`]: {
            width: '100%',
            [`& .${tileImageClassName}`]: {
                width: '100%',
                [`& > div`]: {
                    width: '100%',
                },
            },
            [`& .${tileImageSlotClassNames.imageContainer}`]: {
                width: '100%',
            },
        },
    },
});

export const Header: StyleRule = ({ theme }) => ({
    [`& > div`]: {
        padding: pxArrayToRem([0, 18]),
    },

    [theme.screen.laptop]: {
        [`& > div`]: {
            padding: pxArrayToRem([0, 36]),
        },
    },

    [theme.screen.clamped]: {
        [`& > div`]: {
            padding: 0,
        },
    },
});
export const Container: StyleRule = () => ({
    padding: 0,
    margin: pxArrayToRem([0, -14]),
});
export const ViewMore: StyleRule = ({ theme }) => ({
    margin: pxArrayToRem([30, 18, 14]),

    // Change font only for mobile
    [theme.screen.max.laptop]: {
        [`& .${labelClassName}`]: {
            ...theme.siteVariables.textStyles.Heading.Medium65,
            textTransform: 'uppercase',
        },
    },

    [theme.screen.laptop]: {
        width: 'fit-content',
        padding: pxArrayToRem([24, 59.5]),
        margin: pxArrayToRem([120, 0, 0, 14]),
    },
});

export const CarouselContainer: StyleRule = ({ theme }) => ({
    padding: pxArrayToRem([24, 0, 40]),

    [theme.screen.laptop]: {
        padding: pxArrayToRem([160, 0, 40]),
    },
});

export const ArticleGridMobile: StyleRule = () => ({
    marginTop: pxToRem(50),

    '& >:only-child ': {
        marginTop: 0,
    },

    [`& .${archizeenTileClassName}`]: {
        borderBottom: `1px solid rgba(52, 52, 52, 0.2)`,
        marginBottom: '-1px',

        [`&:first-child`]: {
            borderTop: `1px solid rgba(52, 52, 52, 0.2)`,
        },

        [`& > .${flexClassName} > .${flexClassName}`]: {
            margin: pxArrayToRem([0, 4, 8, 0]),

            [`& .${captionClassName}`]: {
                minHeight: pxToRem(13),
            },

            [`& > .${flexClassName}`]: {
                margin: pxArrayToRem([2, 0, 0, 0]),
            },
        },
    },
});

export const FeaturedArticleMobile: StyleRule = ({ theme }) => ({
    [`& .${archizeenTileClassName}`]: {
        width: '100%',
        [`& .${SubheaderClassName}`]: {
            letterSpacing: theme.siteVariables.letterSpacingSmall,
        },
    },
});
